import {DependencyList, EffectCallback, useContext, useEffect, useLayoutEffect, useState} from 'react';
import BridgeContext from '../context/BridgeContext';

function useReady(effect: EffectCallback, deps: DependencyList = []) {
  const bridge = useContext(BridgeContext);
  const [isReady, setReady] = useState<boolean>(false);
  useLayoutEffect(() => {
    if (isReady) {
      return effect();
    }
  }, [isReady, ...deps]);
  useEffect(() => {
    bridge.ready(() => {
      setReady(true)
    })
  }, [bridge]);
}

export default useReady;
